/** How much of an account's activity a viewer may see */
export type ActivityAccess = 'all' | 'ownStretches' | 'none'

type GetActivityAccessProps = {
  /** False for roles the workflow hides previous activity from */
  canSeeHistory: boolean
  /** account:manage on the account: they manage its team, owner or closer */
  canManageAccount: boolean
  /** May update the account */
  canEditAccount: boolean
  isCurrentOwner: boolean
}

/**
 * Only roles the workflow restricts are limited. Without update rights (a former owner included) nothing shows;
 * the current owner sees the stretches they had the account. Anyone else who can update someone else's account
 * (a manager, even without account:manage) oversees it, so sees everything.
 */
export const getActivityAccess = ({
  canSeeHistory,
  canManageAccount,
  canEditAccount,
  isCurrentOwner,
}: GetActivityAccessProps): ActivityAccess => {
  if (canSeeHistory || canManageAccount) return 'all'
  if (!canEditAccount) return 'none'
  if (isCurrentOwner) return 'ownStretches'
  return 'all'
}
